import axios from "axios";
import {Invoice} from "@/api/types";
import getApiDomain from "@/api/getApiDomain";

const getInvoices = async () => {
	const response = await axios.get<Invoice[]>(getApiDomain() + "/api/invoice", {
		headers: {
			'X-HTTP-AUTHORIZATION': `Authenticate ${localStorage.getItem("auth_token")}`,
			'Access-Control-Allow-Origin': '*',
		}
	}).catch(function (e) {
		const error = e.toJSON();
		if(error.status !== 500){
			throw e;
		}
	});
	if(!response){
		return [];
	}
	return response.data;
};

export default getInvoices;
